'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCardTravel = function MdCardTravel(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 23.4v-10h-5v3.2h-3.4v-3.2h-10v3.2h-3.4v-3.2h-5v10h26.8z m0 8.2v-3.2h-26.8v3.2h26.8z m-18.4-25v3.4h10v-3.4h-10z m18.4 3.4c1.8 0 3.2 1.5 3.2 3.4v18.2c0 1.9-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.5-3.2-3.4v-18.2c0-1.9 1.4-3.4 3.2-3.4h5v-3.4c0-1.8 1.5-3.2 3.4-3.2h10c1.9 0 3.4 1.4 3.4 3.2v3.4h5z' })
        )
    );
};

exports.default = MdCardTravel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/card-travel.js
// module id = 2678
// module chunks = 0